import { Routes } from '@angular/router';

import { VANILLA_SECONDARY_ROUTES } from '@frontend/loaders/routes';

import { lastKnownProductRedirectFunction, productStyleBundleGuard } from './guards';
import { defaultRoutes } from './routes/default.routes';
import productRoutes from './routes/product.routes';

export const appRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: lastKnownProductRedirectFunction,
    },
    {
        path: '{culture}/maintenance/:product',
        loadComponent: () => import('./maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
        data: { vanillaRoute: true },
    },
    {
        path: '{culture}',
        children: [...defaultRoutes, ...productRoutes.routes],
        canActivateChild: [productStyleBundleGuard],
    },
    ...VANILLA_SECONDARY_ROUTES,
    ...(productRoutes.topLevelRoutes ?? []),
    {
        path: '',
        outlet: 'overlay',
        children: [],
    },
    {
        path: '**',
        loadChildren: () => import('@frontend/vanilla/features/not-found').then((m) => m.ROUTES),
    },
];
